import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import YouTube from 'youtube-iframe';
import Player from '@vimeo/player';

gsap.registerPlugin(ScrollTrigger);

export default class VideoHandler {
	customPlayer() {
	// 	const videoContainer = document.getElementById("vimeo-container");
	// 	if (!videoContainer) return;
	// 
	// 	const url = videoContainer.getAttribute("data-video");
	// 	if (!url) return;
	// 
	// 	const { type, id } = getVideoTypeAndId(url);
	// 	if (!type || !id) {
	// 		videoContainer.innerHTML = "<p>Invalid video URL</p>";
	// 		return;
	// 	}
	// 
	// 	if (type === "youtube") {
	// 		loadYouTubePlayer(id);
	// 	} else if (type === "vimeo") {
	// 		loadVimeoPlayer(id);
	// 	}
	// 
	// 	function getVideoTypeAndId(url) {
	// 		const youtubeRegex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([\w-]+)/;
	// 		const vimeoRegex = /(?:vimeo\.com\/(?:video\/)?)(\d+)/;
	// 
	// 		let match;
	// 		if ((match = url.match(youtubeRegex))) {
	// 			return { type: "youtube", id: match[1] };
	// 		} else if ((match = url.match(vimeoRegex))) {
	// 			return { type: "vimeo", id: match[1] };
	// 		}
	// 		return { type: null, id: null };
	// 	}
	// 
	// 	function loadYouTubePlayer(videoId) {
	// 		window.onYouTubeIframeAPIReady = function () {
	// 			new YT.Player(videoContainer, {
	// 				videoId: videoId,
	// 				playerVars: { autoplay: 1, controls: 1 },
	// 				events: {
	// 					onReady: function (event) {
	// 						console.log("YouTube Player Ready");
	// 						event.target.playVideo();
	// 					},
	// 					onError: function (event) {
	// 						console.error("YouTube Error", event);
	// 					},
	// 				},
	// 			});
	// 		};
	// 	}
	// 
	// 	function loadVimeoPlayer(videoId) {
	// 		const vimeoPlayer = new Vimeo.Player(videoContainer, {
	// 			id: videoId,
	// 			autoplay: true,
	// 		});
	// 
	// 		vimeoPlayer.on("loaded", function () {
	// 			console.log("Vimeo Player Ready");
	// 		});
	// 
	// 		vimeoPlayer.on("error", function (error) {
	// 			console.error("Vimeo Error", error);
	// 		});
	// 	}
	// 	
		
		
		
		
		
		
		
		
		
		
		
		const videoContainer = document.getElementById("vimeo-container");
		const bigPlayButton = document.getElementById("custom-play-button");
		const playPauseBtn = document.getElementById("playPauseBtn");
		const seekBar = document.getElementById("seekBar");
		const muteBtn = document.getElementById("muteBtn");
		const customControls = document.querySelector(".custom-controls");
	
		if (!videoContainer) return;
	
		const url = videoContainer.getAttribute("data-video");
		if (!url) return;
	
		const { type, id } = getVideoTypeAndId(url);
		let player;
		let firstPlay = true;
	
		if (type === "youtube") {
			loadYouTubePlayer(id);
		} else if (type === "vimeo") {
			loadVimeoPlayer(id);
		}
	
		function getVideoTypeAndId(url) {
			const youtubeRegex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([\w-]+)/;
			const vimeoRegex = /(?:vimeo\.com\/(?:video\/)?)(\d+)/;
	
			let match;
			if ((match = url.match(youtubeRegex))) {
				return { type: "youtube", id: match[1] };
			} else if ((match = url.match(vimeoRegex))) {
				return { type: "vimeo", id: match[1] };
			}
			return { type: null, id: null };
		}
	
		function loadYouTubePlayer(videoId) {
			window.onYouTubeIframeAPIReady = function () {
				player = new YT.Player(videoContainer, {
					videoId: videoId,
					playerVars: { controls: 0, modestbranding: 1, rel: 0 },
					events: {
						onReady: function (event) {
							setupControls();
						},
						onStateChange: function (event) {
							handlePlaybackState(event.data !== YT.PlayerState.PLAYING);
						},
					},
				});
			};
		}
	
		function loadVimeoPlayer(videoId) {
			player = new Vimeo.Player(videoContainer, {
				id: videoId,
				controls: false,
			});
	
			player.ready().then(() => {
				setupControls();
			});
	
			player.on("play", () => handlePlaybackState(false));
			player.on("pause", () => handlePlaybackState(true));
			player.on("timeupdate", (data) => updateSeekBar(data.seconds, data.duration));
			
			// play.play().then(function () {
			// 	console.log('playing')
			// 	// document.getElementById('custom-play-button').style.display = 'none';
			// });
		}
	
		function setupControls() {
			bigPlayButton.addEventListener("click", togglePlayPause);
			playPauseBtn.addEventListener("click", togglePlayPause);
			seekBar.addEventListener("input", seekVideo);
			muteBtn.addEventListener("click", toggleMute);
	
			if (type === "youtube") {
				setInterval(() => {
					if (player && player.getCurrentTime) {
						updateSeekBar(player.getCurrentTime(), player.getDuration());
					}
				}, 500);
			}
		}
	
		function togglePlayPause() {
			if (type === "youtube") {
				const state = player.getPlayerState();
				if (state === YT.PlayerState.PLAYING) {
					player.pauseVideo();
				} else {
					player.playVideo();
				}
			} else {
				player.getPaused().then((paused) => {
					paused ? player.play() : player.pause();
				});
			}
		}
	
		function handlePlaybackState(isPaused) {
			if (firstPlay) {
				bigPlayButton.classList.add("hidden");
				customControls.classList.remove("hidden");
				firstPlay = false;
			}
			
			playPauseBtn.textContent = isPaused ? "play" : "pause";
		}
		
		function updateSeekBar(currentTime, duration) {
			seekBar.value = (currentTime / duration) * 100;
		}
		
		function seekVideo() {
			const seekTime = (seekBar.value / 100) * (type === "youtube" ? player.getDuration() : player.getDuration().then(d => d));
			if (type === "youtube") {
				player.seekTo(seekTime);
			} else {
				player.setCurrentTime(seekTime);
			}
		}
	
		function toggleMute() {
			if (type === "youtube") {
				if (player.isMuted()) {
					player.unMute();
					muteBtn.textContent = "mute";
				} else {
					player.mute();
					muteBtn.textContent = "unmute";
				}
			} else {
				player.getVolume().then(volume => {
					if (volume > 0) {
						player.setVolume(0);
						muteBtn.textContent = "unmute";
					} else {
						player.setVolume(1);
						muteBtn.textContent = "mute";
					}
				});
			}
		}
	}
	autoplay() {
		gsap.utils.toArray('[data-video="autoplay"]').forEach((video) => {
			const loadVideo = () => {
				if (video.readyState >= 3) {
					video.load();
				}
			};
		
			const playVideo = () => {
				video.play();
			};
		
			if (video.offsetTop < window.innerHeight) {
				loadVideo();
				playVideo();
			} else {
				ScrollTrigger.create({
					trigger: video,
					onEnter: () => {
						loadVideo();
						playVideo();
					},
					onEnterBack: () => {
						playVideo();
					},
				});
			}
		});
	}
}